module.exports = __webpack_public_path__ + "img/e_2_11_g.c409a9ea.png";